// because of the way webpack includes imports,
// code put in the app.js will run after imports.
// Put code here you want to run first

// console.time('app') //uncomment to setup timers


export default {}



// WEBPACK FOOTER //
// ./resources/js/start.js